module.exports = __webpack_public_path__ + "static/media/1009378.1f29ecf2.png";